import React from "react";
import { Link, useRouteMatch } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(() => ({
  showbar: {
    borderBottom: "3px solid #005bff",
    borderRadius: 0,
  },
}));

const HeaderOption = ({ text, link, currentPath }) => {
  const classes = useStyles();
  return (
    <Button
      component={Link}
      to={link}
      color="primary"
      variant="text"
      style={{ marginLeft: "1rem" }}
      className={currentPath === link && classes.showbar}
    >
      {text}
    </Button>
  );
};

export default function Header({ currentPath }) {
  //const classes = useStyles();
  //console.log("got current path: ", currentPath);

  return (
    <AppBar position="fixed" color="inherit">
      <Toolbar style={{ padding: "0 10px" }}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item style={{ flex: 1 }}>
            <Typography
              variant="h5"
              color="secondary"
              component={Link}
              to="/"
              style={{ textDecoration: "none" }}
              gutterBottom
            >
              CryptoPredictor
            </Typography>
          </Grid>
          <Grid item>
            <HeaderOption
              link="/currencies"
              text="Currencies"
              currentPath={currentPath}
            />
            <HeaderOption link="/news" text="News" currentPath={currentPath} />
            <HeaderOption
              link="/about"
              text="About"
              currentPath={currentPath}
            />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
